import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FileIcon } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const FilesPage = lazy(() => import('./pages/FilesPage').then((m) => ({ default: m.FilesPage })))

const feature: FrontendFeature = {
  navItems: [
    { path: '/files', label: 'Files', icon: FileIcon },
  ],
  routes: [
    <Route
      key="files"
      path="/files"
      element={
        <ProtectedRoute>{lazyRoute(<FilesPage />)}</ProtectedRoute>
      }
    />,
  ],
}

export default feature
